/* eslint-disable @typescript-eslint/no-namespace */
import alert from './alert';
import button from './button';
import type { Utility } from '../../../types/utility';

export namespace Banner {
  /** Banner Component Variant Keys */
  export type ComponentKeys = 'alert' | 'button';

  /** Banner Components */
  export type Components = {
    /** Banner Component Variant Types */
    Alert: VariantKeys;
    /** Button Component Variant Types */
    Button: VariantKeys;
  };

  /** Banner Component Variant Keys */
  export type VariantKeys = 'alert' | 'notice' | 'warning' | 'white' | 'announcement';

  /** Banner Component Variants */
  export type Variants = {
    [CompKey in ComponentKeys]: CompKey extends 'alert'
      ? Alert.Variants
      : CompKey extends 'button'
        ? Button.Variants
        : never;
  };

  /** Banner Component Variant Modes */
  export type VariantModes = Variants;

  /** Banner Component Scale Keys */
  export type ScaleKeys = {
    [CompKey in ComponentKeys]: Array<`${CompKey}.${VariantKeys}`>;
  };

  /** Banner Alert Component */
  export namespace Alert {
    /** Banner Alert Component Variant Keys */
    export type VariantKeys = Banner.VariantKeys;

    /** Banner Alert Component Variants */
    export type Variants = {
      [Key in VariantKeys]: Utility.CSSProperties;
    };
  }

  /** Banner Button Component */
  export namespace Button {
    /** Banner Button Component Variant Keys */
    export type VariantKeys = Banner.VariantKeys;

    /** Banner Button Component Variants */
    export type Variants = {
      [Key in VariantKeys]: Utility.CSSProperties;
    };
  }
}

const banner = {
  alert,
  button,
};

const baseBannerVariants = ['alert', 'notice', 'warning', 'white', 'announcement'] as Banner.VariantKeys[];

export const bannerVariants = {
  alert: baseBannerVariants,
  button: baseBannerVariants,
};

export default banner;
